<template>
    <div class="row">
        <div class="col-md-12">
            <p>Copy the following link and paste into your file explorer (or run window) to open the file or folder.</p>
            <div class="input-group">
                <input type="text" :value="linkUrl" readonly class="form-control" ref="linkInput" @focus="linkInputClick" />
                <div class="input-group-append">
                    <button @click="copyLink" class="btn btn-text btn-copy" type="button" data-dismiss="modal"><i :class="copyIcon"></i></button>
                </div>
            </div>
        </div>

        <!-- <div class="row col-md-12">
		<div class="col">
			<button class="btn btn-primary" type="button" @click="closeModal" data-dismiss="modal">Done</button>
		</div>
        </div> -->
    </div>
</template>

<script>


export default {
    props: {
        linkUrl: String,
    },
    data() {
        return {
            copyIcon: "far fa-copy",
            CopyIcontimeout: null,
        }
    },
    methods: {
        linkInputClick() {
            this.$refs.linkInput.select();
        },
        closeModal() {
            this.$bvModal.hide('linkCopyLinkModal');
        },
        async copyLink() {
            this.copyIcon = "far fa-copy";
            clearTimeout(this.CopyIcontimeout);
            const legacyCopyMethod = () => {
                this.$refs.linkInput.select();
                document.execCommand("copy");
                this.copyIcon = "fas fa-check";
                this.CopyIcontimeout = setTimeout(() => {
                    this.copyIcon = "far fa-copy";
                }, 3000);
            }

            const navPer = await navigator.permissions.query({name: "clipboard-write"});
            if (navPer.state == "granted" || navPer.state == "prompt") {
                try {
                    await navigator.clipboard.writeText(this.linkUrl);
                    this.copyIcon = "fas fa-check";
                    this.CopyIcontimeout = setTimeout(() => {
                        this.copyIcon = "far fa-copy";
                    }, 3000);
                } catch {
                    console.error("clipboard API error. Cannot copy to clipboard.")
                    legacyCopyMethod();
                }
            } else {
                legacyCopyMethod();
            }
        },
    }
}
</script>


